export function appendModelingControlParams(params) {
  const gapTarget = document.getElementById("scenario_lw_gap_closure_target")?.value;
  const exchangeDate = document.getElementById("scenario_exchange_rate_date")?.value;
  const currencyDisplay = document.getElementById("scenario_currency_display")?.value;
  const unitDisplay = visibleUnitDisplayInput()?.value;
  const topUpEnabledCheckbox = document.getElementById("scenario_top_up_enabled");
  const topUpPercent = document.getElementById("scenario_top_up_percent")?.value;
  const topUpAmount = document.getElementById("scenario_top_up_amount")?.value;

  if (gapTarget != null) params.set("scenario[lw_gap_closure_target]", gapTarget);
  if (exchangeDate) params.set("scenario[exchange_rate_date]", exchangeDate);
  if (currencyDisplay) params.set("scenario[currency_display]", currencyDisplay);
  if (unitDisplay) params.set("scenario[unit_display]", unitDisplay);
  if (topUpEnabledCheckbox) params.set("scenario[top_up_enabled]", topUpEnabledCheckbox.checked ? "1" : "0");
  if (topUpPercent != null) params.set("scenario[top_up_percent]", topUpPercent);
  if (topUpAmount != null) params.set("scenario[top_up_amount]", topUpAmount);

  const page = new URL(window.location.href).searchParams.get("page");
  if (page) params.set("page", page);

  appendFacilitySelectionParams(params);
  appendIntermediaryModelingInputParams(params);
  appendVolDeclaredByFacilityParams(params);
}

function visibleUnitDisplayInput() {
  const inputs = document.querySelectorAll('[data-scenario-modeling-unit-display-target="unitDisplayInput"]');
  for (const input of inputs) {
    if (input.offsetParent !== null) return input;
  }

  return inputs[0] ?? null;
}

// Vol. Bought is stored in the scenario buyer unit. In producer view the input
// shows a converted value, so convert it back before persisting.
//
// Unit toggles update the visible unit display input before this runs, while inputs still
// show the previous unit — do not rely on the live unit display to infer units.
function volBoughtSubmitValue(input) {
  if (input.value === input.defaultValue && input.dataset.storedValue != null) {
    return input.dataset.storedValue;
  }

  const parsed = Number.parseFloat(String(input.value).replace(/,/g, ""));
  if (!Number.isFinite(parsed)) return input.value;

  const toBuyerFactor = Number.parseFloat(input.dataset.toBuyerFactor);
  if (!Number.isFinite(toBuyerFactor) || toBuyerFactor === 1) {
    return input.value;
  }

  // Keep decimals (e.g. 1780 kg -> 1.78 t); round to 6 places only to strip
  // float conversion noise, matching the volume column's decimal scale.
  return String(Number((parsed * toBuyerFactor).toFixed(6)));
}

export function appendFacilitySelectionParams(params) {
  document.querySelectorAll("[data-scenario-modeling-facility-selection-panel-id-value]").forEach((element) => {
    const panelId = element.dataset.scenarioModelingFacilitySelectionPanelIdValue;
    if (!panelId) return;

    const customized = element.dataset.scenarioModelingFacilitySelectionCustomizedValue === "true";
    const checkboxes = element.querySelectorAll(
      "[data-scenario-modeling-facility-selection-target='facilityCheckbox']:checked"
    );
    const ids = [...new Set(Array.from(checkboxes).map((checkbox) => checkbox.value))];

    if (ids.length === 0 && !customized) return;

    if (ids.length === 0) {
      params.append(`scenario[facility_selection][${panelId}][]`, "");
    } else {
      ids.forEach((id) => params.append(`scenario[facility_selection][${panelId}][]`, id));
    }
  });
}

export function appendIntermediaryModelingInputParams(params) {
  document.querySelectorAll("[data-scenario-modeling-intermediaries-target='volBoughtInput']").forEach((input) => {
    const match = input.name.match(/scenario\[intermediary_modeling_inputs\]\[(\d+)\]\[(\w+)\]/);
    if (!match) return;

    const [, userId, field] = match;
    params.set(`scenario[intermediary_modeling_inputs][${userId}][${field}]`, volBoughtSubmitValue(input));
  });

  document.querySelectorAll("[data-scenario-modeling-intermediaries-target='taxesLeviesInput']").forEach((input) => {
    const match = input.name.match(/scenario\[intermediary_modeling_inputs\]\[(\d+)\]\[(\w+)\]/);
    if (!match) return;

    const [, userId, field] = match;
    params.set(`scenario[intermediary_modeling_inputs][${userId}][${field}]`, input.value);
  });

  document.querySelectorAll("[data-scenario-modeling-intermediaries-target='otherCostsInput']").forEach((input) => {
    const match = input.name.match(/scenario\[intermediary_modeling_inputs\]\[(\d+)\]\[(\w+)\]/);
    if (!match) return;

    const [, userId, field] = match;
    params.set(`scenario[intermediary_modeling_inputs][${userId}][${field}]`, input.value);
  });
}

export function appendVolDeclaredByFacilityParams(params) {
  document.querySelectorAll("[data-scenario-modeling-facility-selection-target='volDeclaredInput']").forEach((input) => {
    if (!input.name) return;

    params.set(input.name, input.value);
  });
}
